import { useState, useEffect } from 'react';

export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenSize.width <= 767;
  const isTablet = screenSize.width >= 768 && screenSize.width <= 991;
  const isLaptop = screenSize.width >= 992 && screenSize.width <= 1199;
  const isDesktop = screenSize.width >= 1200;

  return {
    ...screenSize,
    isMobile,
    isTablet,
    isLaptop,
    isDesktop,
  };
};
